/**
 * TanStack Query hooks for `position-based-attribution`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	positionBasedAttributionQueryKeys,
	type CreatePositionBasedAttributionBody,
	type ListPositionBasedAttributionResponse,
	type PositionBasedAttributionRow,
} from "./api";

export function usePositionBasedAttributionList(): UseQueryResult<ListPositionBasedAttributionResponse, Error> {
	return useQuery({
		queryKey: positionBasedAttributionQueryKeys.list(),
		queryFn: list,
	});
}

export function usePositionBasedAttributionCreate(): UseMutationResult<PositionBasedAttributionRow, Error, CreatePositionBasedAttributionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: positionBasedAttributionQueryKeys.all });
		},
	});
}

export function usePositionBasedAttributionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: positionBasedAttributionQueryKeys.all });
		},
	});
}
